var _rect, _path, _defs;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgFaixa18 = function SvgFaixa18(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.375,
    y: 0.375,
    width: 23.25,
    height: 23.25,
    rx: 5.625,
    fill: "#080808",
    stroke: "url(#paint0_linear_152_1105)",
    strokeWidth: 0.75
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.97692 7.27273H8.24254L6.08203 8.64062V10.277L8.08061 9.02415H8.13175V16H9.97692V7.27273ZM15.3068 16.1193C17.2756 16.1193 18.6903 15.0668 18.6946 13.652C18.6903 12.5611 17.8509 11.6705 16.8026 11.4957V11.4361C17.7145 11.2486 18.3665 10.4602 18.3707 9.50142C18.3665 8.15057 17.071 7.15341 15.3068 7.15341C13.5384 7.15341 12.2429 8.15057 12.2472 9.50142C12.2429 10.456 12.8864 11.2486 13.8153 11.4361V11.4957C12.75 11.6705 11.919 12.5611 11.9233 13.652C11.919 15.0668 13.3381 16.1193 15.3068 16.1193ZM15.3068 14.7642C14.429 14.7642 13.8409 14.2443 13.8409 13.5071C13.8409 12.7528 14.4588 12.2074 15.3068 12.2074C16.1506 12.2074 16.7727 12.7528 16.7727 13.5071C16.7727 14.2486 16.1804 14.7642 15.3068 14.7642ZM15.3068 10.8651C14.5696 10.8651 14.0455 10.3835 14.0455 9.69318C14.0455 9.01136 14.5611 8.54261 15.3068 8.54261C16.0483 8.54261 16.5682 9.01562 16.5682 9.69318C16.5682 10.3835 16.0398 10.8651 15.3068 10.8651Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_152_1105",
    x1: 1.875,
    y1: -6.39469e-7,
    x2: 24,
    y2: 26.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#080808",
    stopOpacity: 0
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFaixa18, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/faixa_18.dcb1ee24.svg";
export { ForwardRef as ReactComponent };